import { TimeSpan } from "@app/shared/lib/TimeSpan";
import { Duration } from "@app/shared/ui/Duration";
import { SpaceSeparator } from "@app/shared/ui/SpaceSeparator";

export type AudioWaveformLevel = number;

export type AudioWaveformProps = {
  currentSec: number;
  durationInSec: number;
  className?: string;
};

export const AudioPlayerDuration: React.FC<AudioWaveformProps> = ({
  currentSec,
  durationInSec,
  className,
}) => {
  return (
    <SpaceSeparator separator="slash" className={className}>
      {currentSec > 0 && (
        <Duration duration={TimeSpan.fromSeconds(currentSec)} includeSeconds />
      )}
      <Duration duration={TimeSpan.fromSeconds(durationInSec)} includeSeconds />
    </SpaceSeparator>
  );
};
